import {Action, getModule, Module, MutationAction, VuexModule} from 'vuex-module-decorators';
import store from '@/store';
import {IStatus} from "@/entity/status/status.types";
import {ResponseDataType} from "@/form/form.types";

@Module({
    namespaced: true,
    name: 'status',
    store,
    dynamic: true,
})
class StatusesModule extends VuexModule {
    status: IStatus[] = [];
    statusLoaded = false;

    @MutationAction
    async fetchAll(): Promise<{ status: IStatus[]; statusLoaded: boolean }> {
        const status = await store.$repository.status.fetchAll();
        let statusLoaded = false;
        if (status.length > 0) {
            statusLoaded = true;
        }
        return {status, statusLoaded};
    }
    @Action({rawError: true})
    async delete(id: number): Promise<ResponseDataType> {
        const resp = await store.$repository.status.delete({id: id});
        return resp;
    }
}

export const StatusesStore = getModule(StatusesModule);
